import React from "react";
import { Image } from 'react-bootstrap';
import imgLoading from '../../assets/img/loading.gif';

const ModalLoading = ( { message} ) => {
    const styleModalLoading = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 9999,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
    }
    return (
        <div style={styleModalLoading}>
            <Image src={imgLoading} alt="Loading" />
            { message && <p>{ message }</p> }
        </div>
    );
};

export default ModalLoading;